import {$authHost} from "./index";
import {CART, CART_ITEM_ID} from "./ApiEndpoints";

export const fetchCartItems = async () => {
    const {data} = await $authHost.get(CART);
    return data;
}

export const addItemToCart = async (itemId) => {
    const {data} = await $authHost.post(CART_ITEM_ID + itemId);
    return data;
}

export const deleteItemFromCart = async (itemId) => {
    const {data} = await $authHost.delete(CART_ITEM_ID + itemId);
    return data;
}

export const clearCart = async () => {
    const {data} = await $authHost.delete(CART);
    return data;
}
